// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xp_a bhs_a bhs_x","StrollerDetailRating__muted":"xp_b bhs_fo"};